import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ROTAS } from '@/shared/lib/rotas';
import { Button } from '@/shared/ui/button';

/**
 * A V1 não tinha rota `*`: URL errada caía no Dashboard silenciosamente, o que
 * escondia link quebrado tanto do usuário quanto de quem escreveu o link.
 */
export function Erro404Page() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-surface p-6 text-center">
      <FileQuestion className="w-16 h-16 text-brand/40" />
      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-foreground">Página não encontrada</h1>
        <p className="text-sm text-muted-foreground max-w-md">
          O endereço acessado não existe ou foi movido.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to={ROTAS.dashboard}>Voltar ao dashboard</Link>
      </Button>
    </div>
  );
}
